import PartsCatalog from './PartsCatalog';

export default PartsCatalog;
